/**
 * Состав пака «product-premium» (WEB-3718) — смысл групп и источник каждого числа:
 * `../stylePackComposition.ts`. Файл на пак, общий список `./index.ts`
 * собирается по каталогу (решение владельца 23.10 ~04:35).
 */
import type { StylePackComposition } from '../stylePack.types';

export const composition: StylePackComposition = {
  // 13 воронок: паки/*.json, поле nearest (ближайший из 12 прежних паков)
  palettes: [
    // 3 из 13 воронок: palette → ближайшая тема по цветам
    { themeId: 'study-blue', weight: 0.23 },
    // 2 из 13 воронок: palette → ближайшая тема по цветам
    { themeId: 'ink-premium', weight: 0.15 },
    // 2 из 13 воронок: palette → ближайшая тема по цветам
    { themeId: 'paper-white', weight: 0.15 },
  ],
  fonts: [
    // 5 из 13 воронок: fontId
    { fontId: 'inter', weight: 0.38 },
    // 4 из 13 воронок: fontId
    { fontId: 'lora', weight: 0.31 },
    // 4 из 13 воронок: fontId
    { fontId: 'poppins', weight: 0.31 },
  ],
  screenKinds: [
    // средняя доля экранов по 13 воронкам (признаки.json kinds) 0.206; сюда свёрнуты Q10, Q13, Q9 (замена из arsenal.mjs)
    { kind: 'Q1', share: 0.23 },
    // средняя доля экранов по 13 воронкам (признаки.json kinds) 0.152
    { kind: 'I1', share: 0.17 },
    // средняя доля экранов по 13 воронкам (признаки.json kinds) 0.113
    { kind: 'N5', share: 0.13 },
    // средняя доля экранов по 13 воронкам (признаки.json kinds) 0.094
    { kind: 'N2', share: 0.11 },
    // средняя доля экранов по 13 воронкам (признаки.json kinds) 0.090
    { kind: 'N8', share: 0.1 },
    // средняя доля экранов по 13 воронкам (признаки.json kinds) 0.086; сюда свёрнуты Q3 (замена из arsenal.mjs)
    { kind: 'Q2', share: 0.1 },
    // средняя доля экранов по 13 воронкам (признаки.json kinds) 0.073
    { kind: 'N1', share: 0.08 },
    // средняя доля экранов по 13 воронкам (признаки.json kinds) 0.070; сюда свёрнуты Q16 (замена из arsenal.mjs)
    { kind: 'N4', share: 0.08 },
  ],
  blocks: [
    // в 9 из 13 воронок (признаки.json blocks), подъём 1.01; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): autoAdvance 56 из 84, optionIndicator 67 из 84
    {
      type: 'single_choice',
      weight: 0.69,
      settings: { autoAdvance: true, optionIndicator: 'none' },
    },
    // в 5 из 13 воронок (признаки.json blocks), подъём 0.85; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): optionIndicator 15 из 20, optionIndicatorStyle 14 из 20, optionIndicatorPosition 14 из 20, optionIconPosition 12 из 20
    {
      type: 'multiple_choice',
      weight: 0.38,
      settings: {
        optionIndicator: 'auto',
        optionIndicatorStyle: 'box',
        optionIndicatorPosition: 'right',
        optionIconPosition: 'left',
      },
    },
    // в 3 из 13 воронок (признаки.json blocks), подъём 1.42
    { type: 'name_field', weight: 0.23, settings: {} },
  ],
  niches: [
    // 3 из 13 воронок (признаки.json theme)
    { niche: 'beauty', weight: 0.23 },
    // 2 из 13 воронок (признаки.json theme)
    { niche: 'education', weight: 0.15 },
    // 2 из 13 воронок (признаки.json theme)
    { niche: 'language_learning', weight: 0.15 },
  ],
};
